<template>
  <delegation-form></delegation-form>
</template>

<script>
import DelegationForm from "../../components/Delegation/DelegationForm";
export default {
  name: "DelegationNewFromOrderView",
  components: { DelegationForm }
};
</script>

<style scoped></style>
